export const ForgotPassword = {
	title: "Glemt passord",
	explanation_text:
		"Skriv inn e-postadressen din, så sender vi deg instruksjoner for å tilbakestille passordet ditt.",
	button_text: "Send tilbakestillingsinstruksjoner",
	button_loading_text: "Sender tilbakestillingsinstruksjoner...",
	remember_password_text: "Husker du passordet ditt?",
	login_button_text: "Logg inn",
	success_title: "Tilbakestillingsinstruksjoner sendt!",
	success_explanation_text: `
        Hvis e-postadressen din finnes i systemet vårt, vil du motta instruksjoner for å tilbakestille passordet ditt.
        Vennligst sjekk e-posten din og følg trinnene.
    `,
};
